import { server } from "@/api";

export const paginate = async (params) => {
    return await server().get('api/purchases', { params });
}

export const all = async (params) => {
    return await server().get('api/purchases', { params: { all: true, ...params } });
}

export const create = async (purchase) => {
    return await server().post('api/purchases', purchase);
}

export const update = async (id, purchase) => {
    return await server().post(`api/purchases/${id}`, purchase);
}

export const remove = async (id) => {
    return await server().delete(`api/purchases/${id}`);
}

export default { paginate, all, create, update, remove };
